"use client";

import React, { type ReactNode } from "react";

import { CaptureError } from "@/shared-web.ui.logger/capture-error";
import { GenericError } from "@/stf.ui/ui.generic-error";

import * as Layout from "../layout/prim.main-layout";
import { ThemeProvider } from "../provider/theme-provider";

interface ProviderWrapperProps {
  children: ReactNode;
}

const ProviderWrapper = (props: ProviderWrapperProps) => {
  const { children } = props;
  return (
    <ThemeProvider>
      {children}
    </ThemeProvider>
  );
};

export default function GlobalError({
  error,
  reset,
}: {
  error: { digest?: string } & Error;
  reset: () => void;
}) {
  return (
    <Layout.Html>
      <Layout.Head />
      <Layout.Body>
        <ProviderWrapper>
          <CaptureError error={error}>
            <GenericError
              error={error}
              reset={reset}
            />
          </CaptureError>
        </ProviderWrapper>
      </Layout.Body>
    </Layout.Html>
  );
}
